import { Injectable } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { ConfirmDialogComponent } from '../components/confirm-dialog/confirm-dialog.component';
import { ConfirmDialogOptions, createConfirmDialogOptions } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ConfirmDialogService {
  private dialogOptions: any = {
    hasBackdrop: true,
    closeOnBackdropClick: false
  };

  constructor(private dialogService: NbDialogService) {}

  open(options: ConfirmDialogOptions) {
    return this.dialogService.open(ConfirmDialogComponent, {
      ...this.dialogOptions,
      context: createConfirmDialogOptions(options)
    });
  }
}
